import cmsFetch from '~/helpers/cms-fetch';
const fetchBooks = cmsFetch('books?format=json').then((r) => r.books.filter((b) => b.book_state !== 'retired'));
export default fetchBooks;
const bookFields = [
    'book_state',
    'book_subjects',
    'cover_url',
    'salesforce_abbreviation',
    'salesforce_name',
    'title',
    'slug',
    'content_warning_text'
].join(',');
function rawToBook(b) {
    const result = b;
    result.subjects = b.book_subjects.map((sObj) => sObj.subject_name);
    return result;
}
export const fetchAllBooks = cmsFetch(`pages/?type=books.Book&fields=${bookFields}&limit=250`)
    .then((r) => {
    for (const b of r.items) {
        rawToBook(b);
    }
    return r.items;
});
